import React, { useEffect } from "react";
import { getOvertimeList } from "../../../../redux/overtime/overtimeState";
import { Pagination } from "antd";
import {  DATE_FORMAT } from "variables/constants";
import OvertimeCard from "./OvertimeCard";
import { CalendarX } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";

const OvertimeTable = ({ dateRange }) => {
  	const dispatch = useDispatch();

	const recordList = useSelector((state) =>  state.overtime.overtimeList?.items);
	const pagination = useSelector((state) => state.overtime.overtimeList?.pagination);
	const filters = useSelector((state) => state.overtime.overtimeList?.filters);


	useEffect(() => {
		const filters = {
			paginate: pagination?.per_page,
		};

		if (dateRange?.length === 2) {
			filters.date_from = dateRange[0].format(DATE_FORMAT);
			filters.date_to = dateRange[1].format(DATE_FORMAT);
		}

		dispatch(getOvertimeList(filters));
	}, [dispatch, pagination?.per_page, dateRange]);

  	return (
	    <div className="max-h-[600px] overflow-y-auto pr-2">
			{recordList?.length > 0 ? (
				<OvertimeCard recordList={recordList} />
			) : (
				<div className="py-10 flex flex-col items-center justify-center text-gray-400">
				<CalendarX className="w-10 h-10 mb-3" />
				<span className="text-sm">
					No overtime records found
				</span>
				</div>
			)}


            {pagination?.total > pagination?.per_page && (
                <div className="flex justify-end py-4">
                    <Pagination
                        current={pagination?.current_page}
                        pageSize={pagination?.per_page}
                        total={pagination?.total}
                        showSizeChanger={false}
                        onChange={(page) =>
							dispatch(
								getOvertimeList({
									...filters,
									page,
									paginate: pagination?.per_page,
								})
							)
						}
                    />
                </div>
            )}
        </div>
  	);
};

export default (OvertimeTable);
